"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripHTMLTags = exports.smartDocPreviewToString = exports.SmartDocFieldLogic = void 0;
const smartdoc_1 = require("@smartsuite/smartdoc");
const isPlainObject_1 = __importDefault(require("lodash-es/isPlainObject"));
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const clipboard_1 = require("../../clipboard/clipboard");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const clipboard_2 = require("../../utils/clipboard");
const comparisons_1 = require("../../comparisons/comparisons");
const dom_1 = require("../../utils/dom");
const migration_1 = require("../../utils/migration");
const text_1 = require("../../utils/text");
const intl_1 = require("../../locale/intl");
const smartdoc_fieldtype_1 = require("../../safe-field-value/text-fields/smartdoc-field/smartdoc.fieldtype");
const texts_1 = require("../../texts");
const validation_1 = require("../../validation/validation");
const lodash_es_1 = require("lodash-es");
const google_sheet_1 = require("../../utils/google-sheet");
class SmartDocFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "richtextareafield";
        this.label = (0, intl_1.$t)(texts_1.smartDocFieldText.smartdoc);
        this.icon = "smartdoc";
        this.iconColor = "#FFB938";
        this.placeholder = (0, intl_1.$t)(texts_1.smartDocFieldText.type_something_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.smartDocFieldText.string),
            (0, intl_1.$t)(texts_1.smartDocFieldText.document),
            (0, intl_1.$t)(texts_1.smartDocFieldText.paragraph),
            (0, intl_1.$t)(texts_1.smartDocFieldText.rich_text),
            (0, intl_1.$t)(texts_1.smartDocFieldText.markup),
        ];
        this.singleExportEligible = true;
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
        };
        this.fieldValueGetter = new smartdoc_fieldtype_1.SmartDocFieldValueGetter();
        this.clipboardPasteRules = clipboard_1.docPasteRules;
        // @ts-expect-error: Need to resolve
        this.migrationRules = {
            textfield: (0, migration_1.clipboardToMigrate)(clipboard_2.clipboardAnyToText),
            textareafield: (0, migration_1.clipboardToMigrate)(clipboard_2.clipboardAnyToText),
            richtextareafield: (0, migration_1.clipboardToMigrate)(clipboard_1.selfToDoc),
        };
    }
    get validators() {
        return { required: validation_1.requiredDoc };
    }
    valueToString(fieldValue) {
        var _a;
        const text = (0, exports.stripHTMLTags)((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.html) !== null && _a !== void 0 ? _a : "");
        return (0, text_1.removeNewLinesAndExcessSpaces)(text);
    }
    valueToExcelExport(fieldValue, field, userPreferences, _record) {
        return {
            t: "s",
            v: getSmartDocText(fieldValue.data, "\n"),
        };
    }
    valueToGoogleSheet(fieldValue, field, userPreferences, _record) {
        return (0, google_sheet_1.makeRowDataValues)(getSmartDocText(fieldValue.data, "\n"), "stringValue");
    }
    processFieldValue(record, slug, comparison, field) {
        const fieldValue = super.processFieldValue(record, slug, comparison, field);
        return (0, exports.smartDocPreviewToString)(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.preview);
    }
    getEmptyValue() {
        return { data: types_1.emptyDoc, html: "", preview: "" };
    }
    /**
     * Checks for different doc empty values.
     *
     * @param fieldValue        field value is gotten by field slug
     */
    isValueEmpty(fieldValue) {
        return !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.preview);
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            saveKeys: ["Tab"],
            deleteValueOnFirstKeypress: false,
            allowAddRecordToGroup: false,
        };
    }
    getViewControlRules(field) {
        return {
            ...super.getViewControlRules(field),
            fieldInGroup: "disable",
        };
    }
    isValueEqual(fieldValue1, fieldValue2) {
        var _a, _b, _c, _d, _e, _f;
        if (this.isPartialValue(fieldValue1) && this.isPartialValue(fieldValue2)) {
            const preview1 = (_a = fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.preview) !== null && _a !== void 0 ? _a : "";
            const preview2 = (_b = fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.preview) !== null && _b !== void 0 ? _b : "";
            return preview1 === preview2;
        }
        // Handles the case when a partial value is deleted from the grid.
        if (((0, react_fast_compare_1.default)(this.getEmptyValue(), fieldValue1) && (fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.preview)) ||
            ((0, react_fast_compare_1.default)(this.getEmptyValue(), fieldValue2) && (fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.preview))) {
            return false;
        }
        // TODO: Need to resolve type for Doc.type
        if ((0, smartdoc_1.isDocEmpty)(fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.data) &&
            (0, smartdoc_1.isDocEmpty)(fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.data)) {
            // If both docs are empty we always return true, this includes empty paragraphs
            return true;
        }
        const fieldValue1Content = (_d = (_c = fieldValue1 === null || fieldValue1 === void 0 ? void 0 : fieldValue1.data) === null || _c === void 0 ? void 0 : _c.content) !== null && _d !== void 0 ? _d : [];
        const fieldValue2Content = (_f = (_e = fieldValue2 === null || fieldValue2 === void 0 ? void 0 : fieldValue2.data) === null || _e === void 0 ? void 0 : _e.content) !== null && _f !== void 0 ? _f : [];
        return (0, react_fast_compare_1.default)(fieldValue1Content, fieldValue2Content);
    }
    isFieldExpandableOnRecordModal() {
        return true;
    }
    /**
     * Determines whether load full value for the field is necessary
     */
    isFullValueLoadNeeded(value) {
        return !value || (!!value.preview && !("data" in value));
    }
    /**
     * Determines whether filed value is partial
     */
    isPartialValue(value) {
        return !!value && (0, isPlainObject_1.default)(value) && !("data" in value);
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            headerAlignment: "left",
        };
    }
    sortKey(fieldValue) {
        var _a;
        return (0, exports.smartDocPreviewToString)((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.preview) !== null && _a !== void 0 ? _a : "");
    }
    searchKey(fieldValue) {
        var _a;
        return (0, exports.smartDocPreviewToString)((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.preview) !== null && _a !== void 0 ? _a : "");
    }
    getContentSize(fieldValue) {
        var _a;
        const strValue = (0, exports.smartDocPreviewToString)((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.preview) !== null && _a !== void 0 ? _a : "");
        return (0, dom_1.getTextSize)(strValue);
    }
    showActivityUpdate(fieldValue) {
        return !this.isValueEmpty(fieldValue) && fieldValue.preview !== "…";
    }
    canChangeValue(_field, fromValue, toValue) {
        return this.isValueEqual(fromValue, toValue);
    }
    groupByKey() {
        return "";
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.SmartDocFieldLogic = SmartDocFieldLogic;
const smartDocPreviewToString = (preview) => {
    if (!preview) {
        return "";
    }
    return (0, exports.stripHTMLTags)(preview.trim()).trim();
};
exports.smartDocPreviewToString = smartDocPreviewToString;
const stripHTMLTags = (html) => {
    var _a;
    const doc = new DOMParser().parseFromString(html, "text/html");
    return (_a = doc.body.textContent) !== null && _a !== void 0 ? _a : "";
};
exports.stripHTMLTags = stripHTMLTags;
function getSmartDocText(node, delimiter = " ") {
    try {
        return nodeToStr(node, delimiter).trim();
    }
    catch (e) {
        return "";
    }
}
function nodeToStr(node, delimiter = " ") {
    var _a, _b, _c;
    const nodeText = node.text;
    const nodeType = node.type;
    const nodeContent = (_a = node.content) !== null && _a !== void 0 ? _a : [];
    if (nodeText) {
        return nodeText;
    }
    if (nodeType === "mention") {
        return (((0, lodash_es_1.toString)((_b = node.attrs) === null || _b === void 0 ? void 0 : _b.prefix) || "") +
            ((0, lodash_es_1.toString)((_c = node.attrs) === null || _c === void 0 ? void 0 : _c.title) || "") +
            " ");
    }
    if (nodeType === "attachment" || nodeType === "image") {
        return "";
    }
    if (nodeType === "paragraph") {
        return nodeContent
            .map((item) => nodeToStr(item, delimiter))
            .join("")
            .trim();
    }
    if (nodeType === "hard_break") {
        return "\n";
    }
    if (nodeContent.length > 0) {
        return nodeContent
            .map((item) => nodeToStr(item, delimiter))
            .join(delimiter);
    }
    return "";
}
